<template>
  <div class="flex items-start gap-4 px-4 py-2">
    <!-- Cards -->
    <div class="flex flex-col gap-3 flex-1">
      <!-- CARD INICIAL -->
      <div
        class="border border-grey-light rounded-lg px-6 py-4 flex items-center gap-8"
      >
        <div class="flex flex-col gap-1">
          <label class="ft-label">Técnicos Iniciais</label>
          <vs-input
            v-model="local.tecnicos_iniciais"
            :disabled="disabled || lockHorasTecnicos"
            :danger="erros.tecnicos_iniciais"
            danger-text="Mínimo 1"
            color="dark"
            icon="QTD"
            icon-after="true"
            min="1"
            type="number"
          />
        </div>

        <div class="flex flex-col gap-1">
          <label class="ft-label">Horas Iniciais</label>
          <vs-input
            v-model="local.horas_iniciais"
            :disabled="disabled || lockHorasTecnicos"
            :danger="erros.horas_iniciais"
            danger-text="Mínimo 1"
            color="dark"
            icon="HRS"
            icon-after="true"
            min="1"
            type="number"
          />
        </div>

        <div class="w-px self-stretch bg-grey-light mx-2"></div>

        <div class="flex space-x-16">
          <div class="flex flex-col gap-1">
            <label class="ft-label">Metodologia:</label>
            <div class="flex gap-6">
              <div class="flex flex-col items-center gap-1">
                <span class="ft-switch-label">FOG</span>
                <vs-switch
                  v-model="fogInicialAtivo"
                  color="success"
                  :disabled="disabled"
                  @input="onFogInicialChange"
                />
              </div>
              <div class="flex flex-col items-center gap-1">
                <span class="ft-switch-label">UBV</span>
                <vs-switch
                  v-model="ubvInicialAtivo"
                  color="success"
                  :disabled="disabled"
                  @input="onUbvInicialChange"
                />
              </div>
            </div>
          </div>
          <div class="flex flex-col gap-1">
            <label class="ft-label">Utilitário:</label>
            <div class="flex flex-col items-center gap-1">
              <span class="ft-switch-label">Escada</span>
              <vs-switch
                v-model="escadaInicialAtivo"
                color="success"
                :disabled="disabled"
                @input="onEscadaInicialChange"
              />
            </div>
          </div>
        </div>

        <div class="w-px self-stretch bg-grey-light mx-2"></div>

        <div class="flex flex-col items-center gap-1">
          <label class="ft-label">Veículo:</label>
          <span
            :class="temEquipamentoInicial ? 'text-blue-600' : 'text-purple-600'"
            :title="
              temEquipamentoInicial
                ? 'Carro — usado quando há FOG, UBV ou Escada no serviço inicial'
                : 'Moto — usado quando não há equipamentos especiais no serviço inicial'
            "
            class="cursor-pointer transition-transform hover:scale-110"
          >
            <template v-if="temEquipamentoInicial">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#64748b"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2"
                />
                <circle cx="7" cy="17" r="2" />
                <path d="M9 17h6" />
                <circle cx="17" cy="17" r="2" />
              </svg>
            </template>
            <template v-else>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#64748b"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="m18 14-1-3" />
                <path d="m3 9 6 2a2 2 0 0 1 2-2h2a2 2 0 0 1 1.99 1.81" />
                <path
                  d="M8 17h3a1 1 0 0 0 1-1 6 6 0 0 1 6-6 1 1 0 0 0 1-1v-.75A5 5 0 0 0 17 5"
                />
                <circle cx="19" cy="17" r="3" />
                <circle cx="5" cy="17" r="3" />
              </svg>
            </template>
          </span>
        </div>
      </div>

      <!-- CARD MANUTENÇÃO -->
      <div
        class="border border-grey-light rounded-lg px-6 py-4 flex items-center gap-8"
      >
        <div class="flex flex-col gap-1">
          <label class="ft-label">Técnicos Manutenção</label>
          <vs-input
            v-model="local.tecnicos_manutencao"
            :disabled="disabled || lockHorasTecnicos"
            :danger="erros.tecnicos_manutencao"
            danger-text="Mínimo 1"
            color="dark"
            icon="QTD"
            icon-after="true"
            min="1"
            type="number"
          />
        </div>

        <div class="flex flex-col gap-1">
          <label class="ft-label">Horas Manutenção</label>
          <vs-input
            v-model="local.horas_manutencao"
            :disabled="disabled || lockHorasTecnicos"
            :danger="erros.horas_manutencao"
            danger-text="Mínimo 1"
            color="dark"
            icon="HRS"
            icon-after="true"
            min="1"
            type="number"
          />
        </div>

        <div class="w-px self-stretch bg-grey-light mx-2"></div>

        <div class="flex space-x-16">
          <div class="flex flex-col gap-1">
            <label class="ft-label">Metodologia:</label>
            <div class="flex gap-6">
              <div class="flex flex-col items-center gap-1">
                <span class="ft-switch-label">FOG</span>
                <vs-switch
                  v-model="fogAtivo"
                  color="success"
                  :disabled="disabled"
                  @input="onFogChange"
                />
              </div>
              <div class="flex flex-col items-center gap-1">
                <span class="ft-switch-label">UBV</span>
                <vs-switch
                  v-model="ubvAtivo"
                  color="success"
                  :disabled="disabled"
                  @input="onUbvChange"
                />
              </div>
            </div>
          </div>
          <div class="flex flex-col gap-1">
            <label class="ft-label">Utilitário:</label>
            <div class="flex flex-col items-center gap-1">
              <span class="ft-switch-label">Escada</span>
              <vs-switch
                v-model="escadaAtivo"
                color="success"
                :disabled="disabled"
                @input="onEscadaChange"
              />
            </div>
          </div>
        </div>

        <div class="w-px self-stretch bg-grey-light mx-2"></div>

        <div class="flex flex-col items-center gap-1">
          <label class="ft-label">Veículo:</label>
          <span
            :class="
              temEquipamentoManutencao ? 'text-blue-600' : 'text-purple-600'
            "
            :title="
              temEquipamentoManutencao
                ? 'Carro — usado quando há FOG, UBV ou Escada na manutenção'
                : 'Moto — usado quando não há equipamentos especiais na manutenção'
            "
            class="cursor-pointer transition-transform hover:scale-110"
          >
            <template v-if="temEquipamentoManutencao">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#64748b"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2"
                />
                <circle cx="7" cy="17" r="2" />
                <path d="M9 17h6" />
                <circle cx="17" cy="17" r="2" />
              </svg>
            </template>
            <template v-else>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#64748b"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="m18 14-1-3" />
                <path d="m3 9 6 2a2 2 0 0 1 2-2h2a2 2 0 0 1 1.99 1.81" />
                <path
                  d="M8 17h3a1 1 0 0 0 1-1 6 6 0 0 1 6-6 1 1 0 0 0 1-1v-.75A5 5 0 0 0 17 5"
                />
                <circle cx="19" cy="17" r="3" />
                <circle cx="5" cy="17" r="3" />
              </svg>
            </template>
          </span>
        </div>
      </div>
    </div>

    <!-- Legenda lateral -->
    <div class="border border-grey-light rounded-lg px-4 py-3 self-stretch flex hidden-legenda" style="min-width: 340px">
      <legendas-forca-trabalho class="w-full" />
    </div>
  </div>
</template>

<script>
import LegendasForcaTrabalho from "../../area/components/legendas-forca-trabalho.vue";

export default {
  name: "ForcaTrabalho",

  components: {
    LegendasForcaTrabalho,
  },

  props: {
    contrato: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    lockHorasTecnicos: {
      type: Boolean,
      default: false,
    },
    podeZerarForca: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      erros: {
        tecnicos_iniciais: false,
        horas_iniciais: false,
        tecnicos_manutencao: false,
        horas_manutencao: false,
      },
      local: {
        tecnicos_iniciais: 1,
        horas_iniciais: 1,
        tecnicos_manutencao: 1,
        horas_manutencao: 1,
        // Manutenção
        fog: 0,
        ubv: 0,
        escada: 0,
        carros: 0,
        motos: 1,
        // Inicial
        fog_inicial: 0,
        ubv_inicial: 0,
        escada_inicial: 0,
        carros_inicial: 0,
        motos_inicial: 1,
      },
      // Switches — Manutenção
      fogAtivo: false,
      ubvAtivo: false,
      escadaAtivo: false,
      // Switches — Inicial
      fogInicialAtivo: false,
      ubvInicialAtivo: false,
      escadaInicialAtivo: false,
    };
  },

  computed: {
    temEquipamentoManutencao() {
      return this.fogAtivo || this.ubvAtivo || this.escadaAtivo;
    },
    temEquipamentoInicial() {
      return (
        this.fogInicialAtivo || this.ubvInicialAtivo || this.escadaInicialAtivo
      );
    },
  },

  watch: {
    contrato: {
      immediate: true,
      deep: false,
      handler(val) {
        if (!val) return;
        this.local.tecnicos_iniciais =
          val.tecnicos_iniciais != null ? val.tecnicos_iniciais : 1;
        this.local.horas_iniciais =
          val.horas_iniciais != null ? val.horas_iniciais : 1;
        this.local.tecnicos_manutencao =
          val.tecnicos_manutencao != null ? val.tecnicos_manutencao : 1;
        this.local.horas_manutencao =
          val.horas_manutencao != null ? val.horas_manutencao : 1;
        // Manutenção
        this.local.fog = val.fog != null ? val.fog : 0;
        this.local.ubv = val.ubv != null ? val.ubv : 0;
        this.local.escada = val.escada != null ? val.escada : 0;
        this.local.carros = val.carros != null ? val.carros : 0;
        this.local.motos = val.motos != null ? val.motos : 1;
        this.fogAtivo = !!val.fog;
        this.ubvAtivo = !!val.ubv;
        this.escadaAtivo = !!val.escada;
        // Inicial
        this.local.fog_inicial = val.fog_inicial != null ? val.fog_inicial : 0;
        this.local.ubv_inicial = val.ubv_inicial != null ? val.ubv_inicial : 0;
        this.local.escada_inicial =
          val.escada_inicial != null ? val.escada_inicial : 0;
        this.local.carros_inicial =
          val.carros_inicial != null ? val.carros_inicial : 0;
        this.local.motos_inicial =
          val.motos_inicial != null ? val.motos_inicial : 1;
        this.fogInicialAtivo = !!val.fog_inicial;
        this.ubvInicialAtivo = !!val.ubv_inicial;
        this.escadaInicialAtivo = !!val.escada_inicial;
      },
    },

    temEquipamentoManutencao(val) {
      this.local.carros = val ? 1 : 0;
      this.local.motos = val ? 0 : 1;
      this.emitUpdate();
    },

    temEquipamentoInicial(val) {
      this.local.carros_inicial = val ? 1 : 0;
      this.local.motos_inicial = val ? 0 : 1;
      this.emitUpdate();
    },

    "local.tecnicos_iniciais"() {
      this.validarCampo("tecnicos_iniciais");
    },
    "local.horas_iniciais"() {
      this.validarCampo("horas_iniciais");
    },
    "local.tecnicos_manutencao"() {
      this.validarCampo("tecnicos_manutencao");
    },
    "local.horas_manutencao"() {
      this.validarCampo("horas_manutencao");
    },
  },

  methods: {
    validarCampo(campo) {
      const valido = this.podeZerarForca || Number(this.local[campo]) >= 1;
      this.erros[campo] = !valido;
      if (valido) {
        this.emitUpdate();
      }
    },
    // Manutenção
    onFogChange(val) {
      this.local.fog = val ? 1 : 0;
      this.emitUpdate();
    },
    onUbvChange(val) {
      this.local.ubv = val ? 1 : 0;
      this.emitUpdate();
    },
    onEscadaChange(val) {
      this.local.escada = val ? 1 : 0;
      this.emitUpdate();
    },
    // Inicial
    onFogInicialChange(val) {
      this.local.fog_inicial = val ? 1 : 0;
      this.emitUpdate();
    },
    onUbvInicialChange(val) {
      this.local.ubv_inicial = val ? 1 : 0;
      this.emitUpdate();
    },
    onEscadaInicialChange(val) {
      this.local.escada_inicial = val ? 1 : 0;
      this.emitUpdate();
    },

    emitUpdate() {
      this.$emit("update", {
        ...this.contrato,
        tecnicos_iniciais: this.local.tecnicos_iniciais,
        horas_iniciais: this.local.horas_iniciais,
        tecnicos_manutencao: this.local.tecnicos_manutencao,
        horas_manutencao: this.local.horas_manutencao,
        // Manutenção
        fog: this.local.fog,
        ubv: this.local.ubv,
        escada: this.local.escada,
        carros: this.local.carros,
        // Inicial
        fog_inicial: this.local.fog_inicial,
        ubv_inicial: this.local.ubv_inicial,
        escada_inicial: this.local.escada_inicial,
        carros_inicial: this.local.carros_inicial,
      });
    },
  },
};
</script>

<style scoped>
@media (max-width: 1610px) {
  .hidden-legenda {
    display: none !important;
  }
}
</style>